/**
 * API utility for authenticated requests
 * Handles both cookie and token-based authentication for iOS Safari compatibility
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Get auth token from storage (tries multiple sources)
export const getAuthToken = () => {
  try {
    const localToken = localStorage.getItem('session_token');
    if (localToken) return localToken;
    
    const sessionToken = sessionStorage.getItem('session_token');
    if (sessionToken) return sessionToken;
  } catch (e) {
    // Storage might be blocked
  }
  return null;
};

// Make authenticated API request
export const authFetch = async (endpoint, options = {}) => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_BASE}${endpoint}`;
  const token = getAuthToken();
  
  const headers = {
    ...options.headers,
  };
  
  // Always add Authorization header if we have a token (critical for iOS)
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  // Add Content-Type for JSON requests
  if (options.body && typeof options.body === 'string') {
    headers['Content-Type'] = headers['Content-Type'] || 'application/json';
  }
  
  return fetch(url, {
    ...options,
    headers,
    credentials: 'include', // Also include cookies as fallback
  });
};

// Convenience methods
export const apiGet = (endpoint, options = {}) => 
  authFetch(endpoint, { ...options, method: 'GET' });

export const apiPost = (endpoint, body, options = {}) => 
  authFetch(endpoint, { 
    ...options, 
    method: 'POST',
    body: typeof body === 'string' ? body : JSON.stringify(body),
  });

export const apiPut = (endpoint, body, options = {}) => 
  authFetch(endpoint, { 
    ...options, 
    method: 'PUT',
    body: typeof body === 'string' ? body : JSON.stringify(body),
  });

export const apiDelete = (endpoint, options = {}) => 
  authFetch(endpoint, { ...options, method: 'DELETE' });
